<style scoped lang="scss" type="text/scss">
    .border-active-container {
        box-sizing: border-box;
        border: .1rem solid transparent;
        transition: all .2s;

        &:hover, &.active {
            cursor: pointer;
            border-color: #3E9EFF;
        }
    }
</style>

<template>
    <div class="border-active-container" :class="{'active': active}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        }
    };
</script>
